import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'

export const columnsCategoryBlanceXS = [
    {
        dataField: 'id',
        text: 'Detalle',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Categoría:' value={row.name} />
                    <TableRowField label='Cantidad:' value={row.quantity} />
                    <TableRowField label='Total (S/):' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
]
export const columnsCategoryBlanceSM = [
    {
        dataField:'id',
        hidden: true
    },
    {
        dataField: 'name',
        text: 'Categoría'
    },
    {
        dataField: 'quantity',
        text: 'Cantidad'
    },
    {
        dataField: 'total',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toMoney(cell)}</span>
            )
        }
    }
];

export const columnsCategorySellsXS = [
    {
        dataField: 'id',
        hidden: true
    },    
    {
        dataField: 'xs',
        text: 'Ventas',
        formatter: (cell, row) => {

            // const item = row.Item
            // const customer = row.Customer;
            // const employee = row.Employee;

            return (
                <div>
                    <TableRowField label='Categoría:' value={row.name} />
                    <TableRowField label='Cliente:' value={`${row.customer}`} />
                    <TableRowField label='Concepto:' value={`${row.item}`} />
                    <TableRowField label='Forma Pago:' value={row.payment} />
                    <TableRowField label='Total (S/):' value={formatHelper.toMoney(row.total_net)} />
                </div>
            )
        }
    }
]

export const columnsCategorySellsSM = [
    {
        dataField: 'id',
        hidden: true
    },
    {
        dataField: 'name',
        text: 'Categoría',
        style: { width: '20%' },
        headerStyle: { width: '20%' }
    },
    {
        dataField: 'xs',
        text: 'Detalle',
        formatter: (cell, row) => {

            const item = row.Item
            const customer = row.Customer;
            const employee = row.Employee;

            return (
                <div>
                    <TableRowField label='Cliente:' value={`${row.customer}`} />
                    <TableRowField label='Concepto:' value={`${row.item}`} />
                </div>
            )
        },
        style: { width: '47%' },
        headerStyle: { width: '47%' }
    },
    {
        dataField: 'payment',
        text: 'Forma Pago',
        style: { width: '18%' },
        headerStyle: { width: '18%' }
    },
    {
        dataField: 'total_net',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toMoney(cell)}</span>
            )
        },
        style: { width: '15%' },
        headerStyle: { width: '15%' }
    }
];

export const columnsCategorySellsMD = [
    {
        dataField: 'id',
        hidden: true
    },    
    {
        dataField: 'name',
        text: 'Categoría'
    },
    {
        dataField: 'customer',
        text: 'Cliente',
        formatter: (cell, row) => {
            return (
                <span>{`${cell} `}</span>
            )
        }
    },
    {
        dataField: 'item',
        text: 'Concepto',
        formatter: (cell, row) => {
            return (
                <span>{`${cell}`}</span>
            )
        }
    },
    {
        dataField: 'payment',
        text: 'Forma Pago'
    },
    {
        dataField: 'total_net',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toMoney(cell)}</span>
            )
        }
    },
];


// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/CategoryBalance/_columns.js